/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
export default {
  components: {
    XButton: XButton
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    height: {
      type: [Number],
      default: 26
    }
  },
  data: function data() {
    return {
      detailShow: this.value,
      // 拓展搜索 显示
      isShow: false
    };
  },
  watch: {
    value: function value(val) {
      this.detailShow = val;
    },
    detailShow: function detailShow(val) {
      var _this = this;
      if (val) {
        this.isShow = true;
      } else {
        setTimeout(function () {
          _this.isShow = false;
        }, 1000);
      }
      this.$emit('input', val);
    }
  }
};